export default function WQInfo () {
    return (
        <>
          <h2 className="text-lg font-semibold mb-4">Water Quality</h2>
          <p className="text-sm text-gray-700 mb-4">
            Select analytes and thresholds for water quality analysis. You must first select BMPs using the BMP Selection tab. 
          </p>
          <p className="text-sm text-gray-700 mb-4">
            Select the <b>Pollutant Removal Tab</b> below to explore inflow and outflow data distributions using jigger-box and whisker plots, and percent removal efficiencies. 
          </p>
          <p className="text-sm text-gray-700 mb-4">
            Select the <b>Performance Index Tab</b> below to explore how well the BMP(s) are contributing to achieving site-specific water quality goals.  
          </p>
          <div className="text-sm text-gray-700 mb-4 flex-1">
            <div className="mb-1">Default threshold concentrations are:</div>
              <ul className="list-disc ml-6">
                <li>Copper - 15 ug/L</li>
                <li>Nitrogen - 2 mg/L</li>
                <li>Phosphorus - 0.2 mg/L</li>
                <li>Total Suspended Solids - 10 mg/L</li>
                <li>Zinc - 15 ug/L</li>
            </ul>
          </div>
          <div className="text-sm text-gray-700 mt-4 mb-4 flex-1">
            For all other pollutants/constituents, the default threshold will be set to 0.5 (in whatever units the constituent is reported in). The default thresholds are not meant to imply any management recommendation. 
          </div>
        </>
    )
}